import i18next from "i18next";

// Pick the language-keyed list out of a { en: [...], th: [...] } option map.
// i18next.language can be a regional code ("en-US") that the map has no key
// for, so fall back to the base language, then English (the i18n default).
export const getLocalizedList = (map) =>
  map?.[i18next.language] ??
  map?.[i18next.language?.split("-")[0]] ??
  map?.en ??
  [];
